import {useState, useCallback, useEffect} from 'react'
import {PageHeader, SaveCancelFooter} from '@/components/molecules'
import {SalesTargetProducts} from '@/containers'
import {Breadcrumb, ProgressIndicator} from '@/components/atoms'
import {useAppDispatch, useAppSelector} from '@/store'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'
// import {setToastNotifications} from '@/store/slices/commonSlice'
import {
  setSalesTargetSelectedCategory,
  addExcludedProduct,
  addIncludedProduct,
  // setSalesTargetFormData,
} from '@/store/slices/salesTargetSlice'
import {Constants} from '@/utils/constants/commonConstants'
import {Tag} from '@/components/atoms'
import {TAG_COLOR} from '@/utils/constants/colors'
import {useProductList} from '@/hooks/useProductList'
import {useCategoryList} from '@/hooks/useCategoryList'

// Lifted cellDataMapperObj
const cellDataMapperObj = {
  productName: ({row: {original} = {}}) => {
    return <div>{original?.productName}</div>
  },
  productId: ({row: {original} = {}}) => {
    return <div>{original?.productId}</div>
  },
  displayName: ({row: {original} = {}}) => {
    return <div>{original?.displayName?.en}</div>
  },
  displaySize: ({row: {original} = {}}) => {
    return <div>{original?.displaySize?.en}</div>
  },
  displayCategory: ({row: {original} = {}}) => {
    return <div>{original?.displayCategory?.en}</div>
  },
  brand: ({row: {original} = {}}) => {
    return <div>{original?.brand?.en}</div>
  },
  subcategory: ({row: {original} = {}}) => {
    return <div>{original?.subcategory?.en}</div>
  },
}

// Lifted ProductListColConfig
const ProductListColConfig = [
  {
    name_of_db_column: 'productName',
    label_of_column: 'Name',
    order_of_column: 1,
  },
  {
    name_of_db_column: 'productId',
    label_of_column: 'Product ID',
    order_of_column: 2,
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'Status',
    order_of_column: 2,
  },
  {
    name_of_db_column: 'displaySize',
    label_of_column: 'Size',
    order_of_column: 3,
  },
  {
    name_of_db_column: 'displayCategory',
    label_of_column: 'Category',
    order_of_column: 4,
  },
  {
    name_of_db_column: 'brand',
    label_of_column: 'Brand',
    order_of_column: 5,
  },
  {
    name_of_db_column: 'includeExclude',
    label_of_column: 'Include/Exclude',
    order_of_column: 6,
  },
]

const AddSalesTargetProduct = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [selectedType, setSelectedType] = useState(Constants.UploadedProducts)
  const [formData, setFormData] = useState({})
  const [uploadComplete, setUploadComplete] = useState(false)
  const [uploadError, setUploadError] = useState(false)
  const salesTarget = useAppSelector(state => state.salesTarget)
  // Category list data
  const {categoryListData} = useCategoryList()
  const {productListData} = useProductList()

  // Selected category from Redux
  const selectedCategory = useAppSelector(state => state.salesTarget.selectedCategory)
  // const excludedProducts = useAppSelector(state => state.salesTarget.excludedProducts)
  const includedProducts = useAppSelector(state => state.salesTarget.includedProducts)

  const handleSetSelectedCategory = newCategories => {
    dispatch(setSalesTargetSelectedCategory(newCategories))
  }

  // Store the row selection state
  const [rowSelection, setRowSelection] = useState([])

  const handleRowSelection = rows => {
    setRowSelection(rows.map(row => row.original.productId))
  }

  const handleRowIncludeExclude = (productId, shouldInclude) => {
    if (shouldInclude) {
      // Add product to includedProducts list
      // Our reducer will also remove it from excludedProducts if present
      dispatch(addIncludedProduct(productId))
    } else {
      // Add product to excludedProducts list
      // Our reducer will also remove it from includedProducts if present
      dispatch(addExcludedProduct(productId))
    }
  }

  const handleBulkAction = shouldInclude => {
    rowSelection.forEach(productId => {
      handleRowIncludeExclude(productId, shouldInclude)
    })
  }

  // This effect runs whenever `selectedCategory` changes:
  // 1) Figures out which products match any of the newly selected categories.
  // 2) Dispatches Redux actions to include or exclude accordingly.
  // useEffect(() => {
  //   if (!productListData?.data || !Array.isArray(productListData.data)) {
  //     return
  //   }

  //   productListData.data.forEach(product => {
  //     const belongsToSelectedCat = selectedCategory?.some(cat => cat.id === product.displayCategoryId)

  //     // If product matches category...
  //     if (belongsToSelectedCat) {
  //       // ...but is NOT in the excluded list,
  //       // then "auto-include" it.
  //       if (!excludedProducts.includes(product.productId)) {
  //         if (!includedProducts.includes(product.productId)) {
  //           dispatch(addIncludedProduct(product.productId))
  //         }
  //       } else {
  //         // It's intentionally excluded, so let's double-check
  //         // we remove it if it somehow ended up in includedProducts:
  //         if (includedProducts.includes(product.productId)) {
  //           dispatch(removeIncludedProduct(product.productId))
  //         }
  //       }
  //     } else {
  //       // If product doesn't belong to the category, remove from included.
  //       if (includedProducts.includes(product.productId)) {
  //         dispatch(removeIncludedProduct(product.productId))
  //       }
  //       // Optionally exclude everything else:
  //       // if (!excludedProducts.includes(product.productId)) {
  //       //   dispatch(addExcludedProduct(product.productId));
  //       // }
  //     }
  //   })
  // }, [selectedCategory, productListData, dispatch, includedProducts, excludedProducts])

  // This effect runs whenever `selectedCategory` changes:
  // 1) Figures out which products match any of the newly selected categories.
  // 2) Dispatches Redux actions to include or exclude accordingly.
  // useEffect(() => {
  //   if (!productListData?.data || !Array.isArray(productListData.data)) {
  //     return
  //   }

  //   productListData.data.forEach(product => {
  //     const belongsToSelectedCat = selectedCategory?.some(cat => cat.id === product.displayCategoryId)

  //     // If product matches category...
  //     if (belongsToSelectedCat) {
  //       // ...but is NOT in the excluded list,
  //       // then "auto-include" it.
  //       if (!excludedProducts.includes(product.productId)) {
  //         if (!includedProducts.includes(product.productId)) {
  //           dispatch(addIncludedProduct(product.productId))
  //         }
  //       } else {
  //         // It's intentionally excluded, so let's double-check
  //         // we remove it if it somehow ended up in includedProducts:
  //         if (includedProducts.includes(product.productId)) {
  //           dispatch(removeIncludedProduct(product.productId))
  //         }
  //       }
  //     } else {
  //       // If product doesn't belong to the category, remove from included.
  //       if (includedProducts.includes(product.productId)) {
  //         dispatch(removeIncludedProduct(product.productId))
  //       }
  //       // Optionally exclude everything else:
  //       // if (!excludedProducts.includes(product.productId)) {
  //       //   dispatch(addExcludedProduct(product.productId));
  //       // }
  //     }
  //   })
  // }, [selectedCategory, productListData, dispatch, includedProducts, excludedProducts])

  const handleNextAction = () => {
    // const ruleSet = {
    //   name: 'string',
    //   rules: [
    //     {
    //       includedCategories: selectedCategory?.map(cat => cat.id) || [],
    //       includedProductIds: includedProducts || [],
    //       excludedCategories: [], // or some logic if you track excluded categories
    //       excludedProductIds: excludedProducts || [],
    //     },
    //   ],
    // }

    // Merge the ruleSet into existing salesTarget.formData
    // dispatch(
    //   setSalesTargetFormData({
    //     ...salesTarget.formData,
    //     ruleSet,
    //   })
    // )

    navigate(ROUTES.REVIEW)
  }
  const handleUpdate = () => {}

  // const handleDraft = () => {
  //   dispatch(setToastNotifications({show: true, message: 'New Sales Target Drafted', type: 'info'}))
  //   navigate(ROUTES.SALES_TARGET_HOME)
  // }
  // const handleCancel = () => {
  //   dispatch(resetSalesTarget())
  //   navigate(ROUTES.SALES_TARGET_HOME)
  // }

  const isProductIncludedDefault = useCallback(
    product => {
      return selectedCategory?.some(cat => cat.id === product?.displayCategoryId)
    },
    [selectedCategory]
  )
  useEffect(() => {
    if (!salesTarget?.displayContent?.en?.title || !salesTarget?.displayContent?.es?.title)
      navigate(ROUTES.ADD_SALES_TARGET)
  })
  const getFormError = () => {
    if (
      salesTarget.targetType === 'Product Target' &&
      Array.isArray(salesTarget?.ruleSet?.rules) &&
      (salesTarget?.ruleSet.rules[0]?.includedProductIds == undefined ||
        salesTarget?.ruleSet.rules[0]?.includedProductIds?.length === 0)
    ) {
      return true
    }
    return false
  }
  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },
            {
              href: '',
              label: 'Add Sales Target Mexico',
            },
          ],
        }}
        id={'astp_bradcrumb'}
      />

      <PageHeader title={'Add Sales Target'} />

      <div className="mb-6">
        <ProgressIndicator
          currentStep={3}
          isDark={true}
          completed={false}
          steps={4}
          titles={[{title: 'Setup'}, {title: 'Display Content'}, {title: 'Products'}, {title: 'Review'}]}
          className="mb-6"
        />
      </div>
      <br />
      <SalesTargetProducts
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        uploadComplete={uploadComplete}
        setUploadComplete={setUploadComplete}
        onUpdate={handleUpdate}
        formData={formData}
        setFormData={setFormData}
        uploadError={uploadError}
        setUploadError={setUploadError}
        cellDataMapperObj={{
          ...cellDataMapperObj,
          includeExclude: ({row: {original} = {}}) => {
            // Determine if this product is included by checking includedProducts in Redux
            const isIncluded = includedProducts.includes(original?.productId)
            return (
              <Tag
                text={isIncluded ? 'Exclude' : 'Include'}
                color={isIncluded ? TAG_COLOR.RED_150 : TAG_COLOR.GREEN_150}
                // Notice we pass productId and !isIncluded here for correct toggling
                onClick={() => handleRowIncludeExclude(original?.productId, !isIncluded)}
              />
            )
          },
        }}
        ProductListColConfig={ProductListColConfig}
        rowSelection={rowSelection}
        setRowSelection={handleRowSelection}
        handleBulkAction={handleBulkAction}
        categoryListData={categoryListData}
        selectedCategory={selectedCategory}
        setSelectedCategory={handleSetSelectedCategory}
        productListData={productListData}
        isProductIncludedDefault={isProductIncludedDefault}
        targetType={salesTarget?.targetType}
      />
      <SaveCancelFooter
        FormError={getFormError()}
        // handleCancel={handleCancel}
        // draftAction={handleDraft}
        nextAction={handleNextAction}
        hideSaveDraft={true}
      />
    </>
  )
}

export default AddSalesTargetProduct
